// extracted by mini-css-extract-plugin
module.exports = {"countryList":"styles_countryList__yiY87","country":"styles_country__28YTz","countryName":"styles_countryName__GMKo4","countryFlag":"styles_countryFlag__cW_j6"};